// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { ProtectedRoute, PaidRoute } from "./components/ProtectedRoute";

// Pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import QuizResult from "./pages/QuizResult";
import PaidConsult from "./pages/PaidConsult";
import FreeConsult from "./pages/FreeConsult";
import DoctorDashboard from "./pages/DoctorDashboard";
import AdminDashboard from "./pages/AdminDashboard";

// Components as pages
import ADHDQuiz from "./components/ADHDQuiz";
import PaymentPage from "./components/PaymentPage";

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Header />
          <Routes>
            {/* Public */}
            <Route path="/" element={<><Home /><Footer /></>} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/quiz" element={<ADHDQuiz />} />
            <Route path="/quiz/result" element={<QuizResult />} />

            {/* Protected - any logged in user */}
            <Route path="/payment" element={
              <ProtectedRoute>
                <PaymentPage />
              </ProtectedRoute>
            } />

            {/* Protected - paid users only */}
            <Route path="/consult/paid" element={
              <PaidRoute>
                <PaidConsult />
              </PaidRoute>
            } />

            {/* Protected - free users */}
            <Route path="/consult/free" element={
              <ProtectedRoute>
                <FreeConsult />
              </ProtectedRoute>
            } />

            {/* Doctor only */}
            <Route path="/doctor" element={
              <ProtectedRoute roles={["doctor", "admin"]}>
                <DoctorDashboard />
              </ProtectedRoute>
            } />
            <Route path="/doctor/*" element={
              <ProtectedRoute roles={["doctor", "admin"]}>
                <DoctorDashboard />
              </ProtectedRoute>
            } />

            {/* Admin only */}
            <Route path="/admin" element={
              <ProtectedRoute roles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/*" element={
              <ProtectedRoute roles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            } />

            {/* Admin only */}
            <Route path="/admin" element={
              <ProtectedRoute roles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/*" element={
              <ProtectedRoute roles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            } />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}
